const LevelsTypes = {
  SET_LEVELS_LOADING: 'LEVELS/SET_LEVELS_LOADING',
  SET_LEVELS_FAILURE: 'LEVELS/SET_LEVELS_FAILURE',
  SET_LEVELS_SUCCESS: 'LEVELS/SET_LEVELS_SUCCESS',
};

export default LevelsTypes;